import React from 'react';
import SendingComponent from 'Pages/Builder/Sending';

export default props => <SendingComponent {...props} />;
